import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=73c12504&"
import script from "./Affiliates.vue?vue&type=script&lang=ts&"
export * from "./Affiliates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports